import { render, staticRenderFns } from "./QualitiesSection.vue?vue&type=template&id=5fc05662&scoped=true&"
import script from "./QualitiesSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./QualitiesSection.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./QualitiesSection.vue?vue&type=style&index=0&id=5fc05662&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc05662",
  null
  
)

export default component.exports